export const originValues = ['bottom-right', 'top-right'];